<div class="row ng-scope">
  <div class="col-12">

    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Thứ</label>
      <div class="col-8">
        <ng-select #slCapTren
                   class="twcol"
                   [tabIndex]="1"
                   [openOnEnter]="false"
                   [items]="inputthus"
                   bindValue="Id"
                   bindLabel="Ten"
                   notFoundText="Không có dữ liệu"
                   [(ngModel)]="doituongSelect.Thu">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell">{{item.Ten}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-4">Từ giờ/đến giờ</label>
      <div class="col-8">
        <kendo-dateinput style="width:45%;float:left" tabIndex="2" [format]="'HH:mm'" [(value)]="doituongSelect.TuNgay"></kendo-dateinput>

        <kendo-dateinput style="width:45%;float:right;margin-left:3px" tabIndex="3" [format]="'HH:mm'" [(value)]="doituongSelect.DenNgay"></kendo-dateinput>
      </div>


    </div>

    <div class="row form-group">
      <label class="control-label col-4 ng-binding">{{'Phòng học' | translate}}</label>
      <div class="col-8">
        <ng-select #slPhongHoc
                   class="twcollong"
                   [tabIndex]="15"
                   [openOnEnter]="false"
                   [items]="inputphonghocs"
                   bindValue="id"
                   bindLabel="ten"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn2"
                   [(ngModel)]="doituongSelect.PhongHocId">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell">{{item.ten}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
    </div>


   


    <div class="row form-group">
      <label class="control-label col-4 ng-binding">Ghi chú</label>
      <div class="col-8">
        <input type="text" tabIndex="5" class="form-control" placeholder="" [(ngModel)]="doituongSelect.GhiChu">
      </div>
    </div>






  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">
    <!--<div class="checkbox c-checkbox">
      <label>
        <input tabIndex="20" type="checkbox" [(ngModel)]="doituongSelect.TrangThaiXuLy" />
        <span class="fa fa-check"></span> Đã xử lý xong
      </label>
    </div>-->
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>


